import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import React from "react";

const Modal = ({
  children,
  title,
}: {
  children: React.ReactNode;
  title: string;
}) => {
  return (
    <Dialog>
      <DialogTrigger className="text-muted-foreground hover:text-secondary-foreground active:text-cta-active focus:text-cta-click underline underline-offset-4">
        {title}
      </DialogTrigger>
      <DialogContent className="max-h-[100vh] md:min-w-[50vw] md:max-h-[calc(100vh-6rem)] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{children}</DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
